module.exports = __webpack_public_path__ + "img/21.635370f6.png";